import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';

import { FsBadgeModule } from '@firestitch/badge';
import { FsDateModule } from '@firestitch/date';
import { FsDialogModule } from '@firestitch/dialog';
import { FsFilterModule } from '@firestitch/filter';
import { FsListModule } from '@firestitch/list';
import { FsNavModule } from '@firestitch/nav';
import { FsSidenavModule } from '@firestitch/sidenav';

import { LogoModule } from '@libs/logo';

import {
    HeaderComponent,
    NavbarComponent,
    SideNavComponent
} from './components';


@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    ScrollingModule,

    MatDialogModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatMenuModule,

    FsSidenavModule,
    FsDialogModule,
    FsBadgeModule,
    FsNavModule,
    FsFilterModule,
    FsListModule,
    FsDateModule,

    LogoModule,
  ],
  declarations: [
    SideNavComponent,
    HeaderComponent,
    NavbarComponent,
  ],
  exports: [
    SideNavComponent,
    HeaderComponent,
  ],
})
export class SideNavModule {}
